import { CardSkeletonLoader, DashboardCard } from '@/components/atoms'

/**
 * CardComponent renders a list of DashboardCard components.
 *
 * @param {Object[]} cardList - The list of card objects to be rendered.
 * @param {Object} cardList[].centralIcon - The central icon for the card.
 * @param {Object} cardList[].ctaPrimary - The primary call-to-action for the card.
 * @param {string} cardList[].title - The title of the card.
 *
 * @returns {JSX.Element} A fragment containing a list of DashboardCard components.
 */
const CardComponent = ({ cardList, isLoading = false }) => {
  if (isLoading) {
    return <div style={{ width: '100%', maxWidth: '100%', padding: 0 }}>
      <CardSkeletonLoader count={cardList?.length || 3} />
    </div>
  }

  return (
    <>
      {cardList?.map((card) => {
        const { centralIcon, ctaPrimary, title } = card || {}
        return (
          <DashboardCard
            centralIcon={centralIcon}
            ctaPrimary={ctaPrimary}
            title={title}
            isDark
            key={crypto.randomUUID()}
          />
        )
      })}
    </>
  )
}

export default CardComponent
